import { render } from "./EditNewUser.vue?vue&type=template&id=b3f8ede2&scoped=true&ts=true"
import script from "./EditNewUser.ts?vue&type=script&lang=ts"
export * from "./EditNewUser.ts?vue&type=script&lang=ts"

import "./EditNewUser.vue?vue&type=style&index=0&id=b3f8ede2&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f8ede2"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QSelect,QItem,QItemSection,QItemLabel,QBtn});
